import React, { useState, useReducer, useRef, useEffect } from 'react'

// styles
import { WrapFilterTrans } from './index.styles'

// component
import TitleDropdownFilter from '../../../../../Control/TitleDropdownFilter'
import BoxFilterByText from '../../../../../Control/BoxFilterByText'

// hooks
import { useOnClickOutside } from '../../../../../../hook/useClickOutside.hook'
import useDebounce from '../../../../../../hook/useDebouce.hook'
import usePrevious from '../../../../../../hook/usePrevious'

const DropDownFilterTranCodes = ({ values, onChangeValues }) => {

    const filterTransRef = useRef()

    const [activeFilter, setActiveFilter] = useState(false)
    const [isShowDropdown, setIsShowDropdown] = useState(false)
    const [stateFilter, dispatchStateFilter] = useReducer(
        (state, action) => ({ ...state, ...action }),
        {
            sort: "",
            searchKey: ""
        }
    )

    const searchKeyDebounce = useDebounce(stateFilter.searchKey, 500)
    const prevSearchKeyDebounce = usePrevious(searchKeyDebounce)

    const _handleOpenBox = () => {
        setIsShowDropdown(!isShowDropdown)
    }

    useOnClickOutside(filterTransRef, () => setIsShowDropdown(false))

    useEffect(() => {
        const { sort, searchKey } = stateFilter

        const haveFilter = sort || searchKey

        if(haveFilter && !activeFilter) {
            setActiveFilter(true)
            return
        }

        if(!haveFilter && activeFilter) {
            setActiveFilter(false)
            return
        }

    }, [JSON.stringify(stateFilter), activeFilter])

    useEffect(() => {
        dispatchStateFilter({ sort: values.sort })
    }, [values.sort])

    useEffect(() => {
        dispatchStateFilter({ searchKey: values.searchKey })
    }, [values.searchKey])

    useEffect(() => {
        if(searchKeyDebounce === prevSearchKeyDebounce) return;
        if(prevSearchKeyDebounce === undefined) return;

        onChangeValues({
            ...stateFilter,
            searchKey: searchKeyDebounce
        })
    }, [searchKeyDebounce, prevSearchKeyDebounce, onChangeValues, JSON.stringify(stateFilter)])

    return (
        <WrapFilterTrans ref={filterTransRef}>
            <TitleDropdownFilter onClick={_handleOpenBox} active={activeFilter}>Mã GD</TitleDropdownFilter>
            {
                isShowDropdown &&
                <BoxFilterByText 
                    stateFilter={stateFilter}
                    dispatchStateFilter={dispatchStateFilter}
                    onChangeValues={onChangeValues}
                />
            }
        </WrapFilterTrans>
    )
}

export default DropDownFilterTranCodes
